import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  categories: [],
  breadcrumbs: [],
  context: null,
  error: false,
  isFetching: false,
})

const quickass = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.RECEIVE_QUICKASS_CATEGORIES:
      if (error) {
        return state.merge({ error: true, isFetching: false })
      }
      return state.merge({
        categories: payload.data.categoryCounters || initialState.categories,
        breadcrumbs: payload.data.breadcrumbs || initialState.breadcrumbs,
        context: payload.context,
        isFetching: false,
      })
    case actions.REQUEST_QUICKASS_CATEGORIES:
      return state.merge({
        error: false,
        isFetching: true,
      })
    default:
      return state
  }
}

export default quickass
